"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryCatchAsync = exports.pollUntil = exports.SingletonPromiseMap = exports.debounceAsync = exports.chunkAndBatchInSeriesAsync = exports.rejectedPromises = exports.fulfilledPromises = exports.isRejected = exports.isFulfilled = exports.explicitlyDoNotHandleError = exports.timeout = exports.sleep = exports.deferredPromise = exports.forEachAsyncUntil = exports.forEachAsync = void 0;
const ramda_1 = require("ramda");
const forEachAsync = async (xs, cb) => {
    for (const x of xs) {
        await cb(x);
    }
};
exports.forEachAsync = forEachAsync;
const forEachAsyncUntil = async (xs, cb) => {
    for (const x of xs) {
        const result = await cb(x);
        if (result) {
            break;
        }
    }
};
exports.forEachAsyncUntil = forEachAsyncUntil;
function deferredPromise() {
    let resolve = (_) => { };
    let reject = (_reason) => { };
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return { promise, resolve, reject };
}
exports.deferredPromise = deferredPromise;
const sleep = async (ms) => new Promise((resolve) => setTimeout(resolve, ms));
exports.sleep = sleep;
const timeout = (promise, ms) => {
    let timeout;
    const timeoutPromise = new Promise((resolve) => (timeout = setTimeout(() => resolve({ timedout: true }), ms)));
    return Promise.race([
        promise
            .then((value) => ({ timedout: false, value }))
            .finally(() => clearTimeout(timeout)),
        timeoutPromise,
    ]);
};
exports.timeout = timeout;
const explicitlyDoNotHandleError = () => { };
exports.explicitlyDoNotHandleError = explicitlyDoNotHandleError;
const isFulfilled = (p) => p.status === "fulfilled";
exports.isFulfilled = isFulfilled;
const isRejected = (p) => p.status === "rejected";
exports.isRejected = isRejected;
const fulfilledPromises = (p) => p.filter(exports.isFulfilled);
exports.fulfilledPromises = fulfilledPromises;
const rejectedPromises = (p) => p.filter(exports.isRejected);
exports.rejectedPromises = rejectedPromises;
async function chunkAndBatchInSeriesAsync(fn, argArray, chunkSizeLimit) {
    const chunkedArgs = (0, ramda_1.splitEvery)(chunkSizeLimit, argArray);
    return chunkedArgs.reduce(async (allValues, chunk) => {
        const allValuesResolved = await allValues;
        const resolvedValues = await Promise.all(chunk.map((args) => fn(args)));
        return [...allValuesResolved, ...resolvedValues];
    }, Promise.resolve([]));
}
exports.chunkAndBatchInSeriesAsync = chunkAndBatchInSeriesAsync;
function debounceAsync(f) {
    let queuedArgs = undefined;
    let executionLock = false;
    const runAndReleaseLockIfThrowsWithNothingQueued = async (f, args) => {
        try {
            return await f(...args);
        }
        catch (e) {
            if (!queuedArgs) {
                executionLock = false;
                throw e;
            }
            else {
                return undefined;
            }
        }
    };
    const runDebounced = async (...args) => {
        if (!executionLock) {
            executionLock = true;
            let returnValue = await runAndReleaseLockIfThrowsWithNothingQueued(f, args);
            while (queuedArgs) {
                const nextArgs = queuedArgs;
                queuedArgs = undefined;
                returnValue = await runAndReleaseLockIfThrowsWithNothingQueued(f, nextArgs);
            }
            executionLock = false;
            return returnValue;
        }
        else {
            queuedArgs = args;
            return undefined;
        }
    };
    return runDebounced;
}
exports.debounceAsync = debounceAsync;
class SingletonPromiseMap {
    map = new Map();
    getOrAdd(key, factory) {
        const existing = this.map.get(key);
        if (existing)
            return existing;
        const newPromise = factory().finally(() => this.map.delete(key));
        this.map.set(key, newPromise);
        return newPromise;
    }
    has(key) {
        return this.map.has(key);
    }
}
exports.SingletonPromiseMap = SingletonPromiseMap;
const pollUntil = async (fn, fnCondition, ms = 1000) => {
    let result = await fn();
    while (!fnCondition(result)) {
        await (0, exports.sleep)(ms);
        result = await fn();
    }
    return result;
};
exports.pollUntil = pollUntil;
async function tryCatchAsync({ try: tryFn, catch: catchFn, }) {
    try {
        return await tryFn();
    }
    catch (e) {
        return await catchFn(e);
    }
}
exports.tryCatchAsync = tryCatchAsync;
//# sourceMappingURL=promises.js.map